<!--  -->
<template>
  <div>
    <el-select v-model="sale_id" placeholder="请选择销售">
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.sale_name"
        :value="item.id"
      />
    </el-select>
    <div style="margin-top:20px">
      <el-button type="primary" @click="dajdw">确定</el-button>
    </div>

  </div>
</template>

<script>
import { privatedomainsales, salerlistwe } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      open_id: null,
      sale_id: null,
      pageIfon: {
        page: 1,
        pageSize: 100
      },
      options: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    sendrw(item) {
      console.log('item', item)
      this.open_id = item.openId
      this.exchangedata()
    },
    async exchangedata() {
      const data = await salerlistwe(this.pageIfon)
      this.options = data.data.list
      // this.total = data.data.total
      console.log('data', data)
    },
    async dajdw() {
      if (this.sale_id === null) {
        this.$message.error('请选择销售')
        return
      }
      const data = await privatedomainsales({
        open_id: this.open_id,
        sale_id: this.sale_id
      })
      this.$message({
        message: '绑定成功',
        type: 'success'
      })
      this.$emit('clsewrwupdata')
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
